import { RouteObject } from 'react-router-dom';

import { BaseModule } from 'lib/modules';

/**
 * Inventory Management Module
 *
 * Owns no routes of its own. The inventory area predates the module and its
 * routes are declared inline in `main.tsx` — several of them behind a
 * per-component flag, which `createRoutes` has no way to express. They're
 * wrapped there in `ModuleProtectedRoute` with `moduleId="INVENTORY"` instead.
 *
 * This registration is what makes the module toggleable and what the nav filter
 * and `useIsModuleActive` check. Per-component switches under it live in the
 * module's `settings` — see `lib/modules/inventory-components.ts`.
 */
class InventoryModuleClass extends BaseModule {
  id = 'INVENTORY';
  name = 'Inventory Management';
  label = 'Inventory Management';
  description =
    'Stock, SKUs, orders, further processing, and the packing/scan stations';
  version = '2.0.0';
  createRoutes = (): RouteObject[] => [];
}

// Export singleton instance
export const InventoryModule = new InventoryModuleClass();
